/* eslint-disable no-unused-vars */
import axios from '../axios'
import configurations from '../configurations'

const search = {
  namespaced: true,
  state: {
    council: configurations.council,
    currentPage: '',
    data: {},
    trading_payments: [],
    form: { id: '' },
    database: '',
    error: null,
    listData: [],
    loading: false,
    years: [],
    metadata: {
      early_renewal: false,
      license_system_year: new Date().getFullYear()
    },
    dbLastUpdated: null,
    lastPayment: {}
  },
  getters: {
    isLoading: function (state, getters, rootState, rootGetters) {
      return state.loading
    }
  },
  mutations: {
    setCurrentPage: (state, payload) => (state.currentPage = payload.currentPage),
    setData: (state, payload) => (state.data = payload.data),
    setDatabase: (state, payload) => (state.database = payload.database),
    setError: (state, payload) => (state.error = payload.error),
    setForm: (state, { form }) => (state.form = Object.assign({}, state.form, form)),
    setListData: (state, payload) => (state.listData = payload.listData),
    setLoading: (state, payload) => (state.loading = payload.loading),
    setTradingPayments: (state, tradingPayments) => (state.trading_payments = tradingPayments),
    setMetadata: (state, { metadata }) => (state.metadata = metadata),
    setLastPayment: (state, payload = { lastPayment: {} }) => (state.lastPayment = payload.lastPayment),
    setYears: (state, { years }) => (state.years = years),
    resetData: (state) => {
      state.data = {}
      state.form = { id: '' }
      state.lastPayment = {}
      state.years = []
      state.trading_payments = []
    }
  },
  actions: {
    searchID: async function (context) {
      context.commit('setLoading', { loading: true })
      try {
        const id = context.state.form.id
        const response = await axios.post(`/query`, { url: btoa(`apply_trading/${id}`) })
        context.commit('setError', { error: null })
        return response.data
      } catch (error) {
        context.commit('setError', { error: { message: 'Data Not Found' } })
        throw error
      } finally {
        context.commit('setLoading', { loading: false })
      }
    },
    async fetchData (context, payload) {
      context.commit('setLoading', { loading: true })
      try {
        if (payload.type === 'assessment' && atob(payload.id).startsWith(`ASVI-`)) {
          const { data } = await axios.post(`/search`, { data: {
            _id: payload.id,
            council: 'mpt',
            payment_type: 'assessment'
          } })
          context.commit('setData', { data })
          return
        }

        if (payload.type.startsWith(`license`) || payload.type.startsWith(`permit`)) {
          const { data } = await axios.post(`/search`, { data: {
            _id: btoa(payload.id),
            council: 'mpt',
            payment_type: payload.type
          } })
          context.commit('setData', { data })
          return
        }
      } catch (error) {
        context.commit('setError', { error: error })
      } finally {
        context.commit('setLoading', { loading: false })
      }
    },
    // epbt-3 fetchTradingRenewal
    async fetchTradingRenewal (context, payload) {
      context.commit('setLoading', { loading: true })
      try {
        const conf = await axios.get(`/licenses/configuration`)
        context.state.metadata.early_renewal = conf.data.early_renewal
        context.commit('setMetadata', {
          metadata: {
            early_renewal: conf.data.early_renewal,
            license_system_year: new Date().getFullYear()
          }
        })
        if (context.state.metadata.early_renewal === true) {
          context.state.years.push(conf.data.system_year)
          context.state.years.push(conf.data.system_year + 1)
        } else if (context.state.metadata.early_renewal === true) {
          context.state.years.push(conf.data.system_year)
        }

        const id = payload.id.trim()
        const res = await axios.post(`/search`, {
          data: {
            _id: btoa(id),
            council: 'mpt',
            payment_type: `license_trading`
          }
        })
        const data = res.data
        context.commit('setData', { data })

        let tradingPayments = [
          {
            jenis_bayaran: 'license_trading',
            ruj_akaun: data.no_lesen,
            bayaran: data.full_payment - data.minimum_payment,
            bayaran2: data.full_payment2 - data.minimum_payment2
          },
          {
            jenis_bayaran: 'process_fee',
            ruj_akaun: data.no_lesen,
            bayaran: data.minimum_payment,
            bayaran2: data.minimum_payment2
          }
        ]
        tradingPayments = tradingPayments.concat(data.renew_Trading)
        context.commit('setTradingPayments', tradingPayments)
      } catch (error) {
        context.commit('setError', { error: error })
      } finally {
        context.commit('setLoading', { loading: false })
      }
    },
    patchData (context, payload) {
      const data = Object.assign({}, context.state.data, payload)
      context.commit('setData', { data })
    },
    resetData (context) {
      context.commit('setData', { data: {} })
      context.commit('setError', { error: null })
      context.commit('setListData', { listData: [] })
    },
    async searchData (context) {
      context.commit('setLoading', { loading: true })

      const currentRoute = context.rootState.route.path
      let currentPage = currentRoute.substr(currentRoute.lastIndexOf('/') + 1)
      context.commit('setCurrentPage', { currentPage })
      let response

      if (currentPage.includes('license') || currentPage.includes('trading')) {
        response = await axios.get(`/licenses`, {
          params: {
            id: btoa(context.state.data.searchId.toString().trim()),
            type: currentPage.includes('trading') ? 'trading_license' : currentPage
          }
        })
      }

      const data = await Object.assign({}, context.state.data)
      const searchIndex = data.searchId.trim()
      if (currentPage === 'assessment') {
        response = await axios.post(`/assessments`, { data: {
          _id: searchIndex,
          council: configurations.council,
          payment_type: '',
          compound_type: '',
          database: ''
        } }, {
          baseURL: configurations.WORKER,
          withCredentials: configurations.withCredentials
        })
      }
      if (currentPage === 'compound') {
        response = await axios.post(`/compounds`, { data: {
          _id: searchIndex.toString().trim().replace(/-/g, ''),
          council: configurations.council,
          payment_type: '',
          compound_type: '',
          database: ''
        } }, {
          baseURL: configurations.WORKER,
          withCredentials: configurations.withCredentials
        })
      }

      if (response.data.rows.length === 0) {
        context.commit('setError', {
          error: { message: 'Record Not found!' }
        })
      } else {
        context.commit('setError', { error: null })
      }
      context.commit('setListData', { listData: response ? [...new Map(response.data.rows.map((item) => [item._rev, item])).values()] : [] })
      context.commit('setData', { data: {} })
      context.commit('setLoading', { loading: false })
      return response
    }
  }
}

export default search
